import { h } from 'preact'
import { Message } from '../../../../../lib/intl/Message'
import { DecorationBottom, DecorationTop, Quote, Snakkedurt } from '../Decorations/Decorations'

import styles from './Ubesvart.css'

export function Ubesvart(props: any) {
  const { parti } = props

  return (
    <div class={styles.flexWrap__ubesvart}>
      <div class={styles.pastandWrapper__ubesvart}>
        <DecorationTop parti={parti} aria-hidden="true" />
        <DecorationBottom parti={parti} aria-hidden="true" />
        {/* eslint-disable-next-line jsx-a11y/aria-role */}
        <div role="text" class={styles.pastand}>
          <Quote parti={parti} aria-hidden="true" />
          <Message as="p" id="hva-mener-partiene-pastand-ubesvart" values={{ parti: parti.navn }} />
          <Snakkedurt aria-hidden="true" />
        </div>
      </div>
    </div>
  )
}
